import { render, staticRenderFns } from "./CreateMergedFieldPopUp.vue?vue&type=template&id=2d31d6c4&scoped=true&"
import script from "./CreateMergedFieldPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateMergedFieldPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateMergedFieldPopUp.vue?vue&type=style&index=0&id=2d31d6c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31d6c4",
  null
  
)

export default component.exports